import { createDefaultTyrann } from '@apis/common';
import { instructionOverview } from '@models/Instruction';

export const instructionApis = createDefaultTyrann({
  '/instruction/overview/': {
    get: {
      response: {
        200: instructionOverview,
      },
    },
  },
});
